import React from 'react';

export default () => {
  if (typeof window !== 'undefined') {
    const newURL = window.location.href
      // Different host
      .replace(/^https?:\/\/[^/]+/, 'https://enzymejs.github.io')
      // Remove trailing slash, to help redirects from pages with file
      // extensions work
      .replace(/(\.[a-z]+)\/$/, '$1');
    window.location.replace(newURL);
  }

  return <p>Enzyme has moved. Redirecting now to <a href="https://enzymejs.github.io">enzymejs.github.io</a>...</p>;
};



// WEBPACK FOOTER //
// ./src/templates/enzymePage.jsx